import React from "react";
import stemmaIntero from "../../styles/images/spinner/StemmaIntero.png";
import metaStemma from "../../styles/images/spinner/MetaStemma.png";

export const SpinnerRegione = () => (
  <div className="stemmaSpinner">
    <div className="wrapper" style={{ background: "url(" + stemmaIntero + ")" }}>
      <div className="pie spinner"></div>
      <div className="pie filler"></div>
      <div className="mask" style={{ background: "url(" + metaStemma + ")" }}></div>
    </div>
  </div>
);
